// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__bno37","row":"style_row__1hbNq","title":"style_title__1SEHD","outlined":"style_outlined__vGqgs"};